﻿/**
 * In this file, we create a React component
 * which incorporates components provided by material-ui.
 */
import React, {Component} from "react";
import PropTypes from "prop-types";
import ErrorSnackBar from "./components/core/error-snackbar";
import NotifySnackBar from "./components/core/notify-snackbar";
import {connect} from "react-redux";
import {MuiThemeProvider} from "material-ui";
import GetMuiTheme from "material-ui/styles/getMuiTheme";

const styles = {
    container: {
        textAlign: 'center',
        paddingTop: 0,
        position: "relative"
    }
};

const muiTheme = GetMuiTheme({
    /*palette: {
     accent1Color: deepPurple800,
     }*/
});

const mapStateToProps = state => ({
    appLoaded: state.common.appLoaded,
    appName: state.common.appName,
    currentUser: state.common.currentUser,
    redirectTo: state.common.redirectTo
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload, token) =>
        dispatch({type: 'APP_LOAD', payload, token, skipTracking: true}),
    onRedirect: () =>
        dispatch({type: 'REDIRECT'})
});

class App extends Component {
    constructor(props, context) {
        super(props, context);

        window.onerror = function (msg, url, lineNo, columnNo, error) {
            const string = msg.toLowerCase();
            const substring = "script error";
            if (string.indexOf(substring) > -1) {
                console.log('Script Error: See Browser Console for Detail');
            } else {
                console.log(msg, url, lineNo, columnNo, error);
            }
            return false;
        };

        window.addEventListener('error', function (e) {
            const error = e.error;
            console.log(error);
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            this.context.router.replace(nextProps.redirectTo);
            this.props.onRedirect();
        }
    }

    componentWillUnmount() {
        const token = window.localStorage.getItem('token');
        this.props.onLoad(token ? "user" : null, token);
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div style={styles.container}>
                    {this.props.children}
                    <ErrorSnackBar/>
                    <NotifySnackBar/>
                </div>
            </MuiThemeProvider>
        );
    }
}

App.contextTypes = {
    router: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(App);